import { WEEKDAYS } from '../catalog/format'
import { DraftWeek, MAX_STRETCHES, addStretch, removeStretch, updateStretch } from '../screens/settings/hoursForm'
import '../screens/settings/Settings.css'
import { IconButton } from '../ui/Icon'

interface DayEditorProps {
  week: DraftWeek
  day: number
  onChange: (week: DraftWeek) => void
  // errors are keyed "day:index", as toWindows and errorsByWindow produce them.
  errors?: Record<string, string>
}

// DayEditor edits one day of a week of stretches. WeekEditor stacks seven of
// them; the Goals screen shows just the day she tapped.
export default function DayEditor({ week, day, onChange, errors = {} }: DayEditorProps) {
  const dayName = WEEKDAYS[day]
  return (
    <section className="hours-day" aria-label={dayName}>
      <div className="hours-day__head">
        <span className="hours-day__name">{dayName}</span>
        {week[day].length === 0 && <span className="hours-day__closed">Closed</span>}
      </div>
      {week[day].map((stretch, index) => {
        const key = `${day}:${index}`
        return (
          <div key={index}>
            <div className="window-row">
              <input
                type="time"
                step={300}
                aria-label={`${dayName} start`}
                value={stretch.start}
                onChange={(e) => onChange(updateStretch(week, day, index, { start: e.target.value }))}
              />
              <span>to</span>
              <input
                type="time"
                step={300}
                aria-label={`${dayName} end`}
                value={stretch.end}
                onChange={(e) => onChange(updateStretch(week, day, index, { end: e.target.value }))}
              />
              <IconButton
                icon="close"
                size={18}
                className="remove-button"
                label={`Remove ${dayName} ${stretch.start} to ${stretch.end}`}
                onClick={() => onChange(removeStretch(week, day, index))}
              />
            </div>
            {errors[key] && <p className="field-error" role="alert">{errors[key]}</p>}
          </div>
        )
      })}
      {week[day].length < MAX_STRETCHES && (
        <button type="button" className="btn btn-quiet btn-compact" onClick={() => onChange(addStretch(week, day))}>
          {week[day].length === 0 ? 'Add hours' : 'Add another stretch'}
        </button>
      )}
    </section>
  )
}
